import type { ReactNode } from 'react';
import { useArtifactAssetUrl } from '@/entities/artifact';
import { useCurrentWorkspaceId } from '@/entities/workspace';
import { AttachmentChip } from './AttachmentChip';

interface Props {
  /** Id of the file-backed artifact; its backing file is resolved + opened on click. */
  artifactId?: string;
  name: string;
  size?: 'sm' | 'lg';
  leading: ReactNode;
  trailing: ReactNode;
}

/**
 * Chip for a file-backed project-context artifact (e.g. a PDF). Resolves the
 * artifact's backing file URL from its id and opens it in a new tab on click —
 * matching how an attached file chip behaves. Falls back to a non-clickable chip
 * until the URL resolves.
 */
export function ProjectContextFileChip(props: Props) {
  const workspaceId = useCurrentWorkspaceId();
  const url = useArtifactAssetUrl(workspaceId, props.artifactId, 'file');

  return (
    <AttachmentChip
      name={props.name}
      size={props.size}
      leading={props.leading}
      onClick={url ? () => window.open(url, '_blank', 'noopener,noreferrer') : undefined}
      trailing={props.trailing}
    />
  );
}
